"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Collection = _interopRequireDefault(require("../../../core/Collection"));
var _utils = require("../../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class LegendStore extends _Collection.default {
  constructor() {
    super(...arguments);
    this._mapping = new Map();
    this._refs = new Map();
  }
  get mapping() {
    return this._mapping;
  }
  get refs() {
    return this._refs;
  }
  add(key, item) {
    const existing = this.get(key);
    if (!existing) {
      super.add(key, item);
    }
    this.increment(key);
  }
  has(key) {
    return (0, _utils.isset)(this.get(key));
  }
  remove(key) {
    let clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const existing = this.get(key);
    if (existing) {
      if (clear) {
        super.remove(key);
        this.mapping.delete(key);
        this.refs.delete(key);
      } else {
        this.decrement(key);
        const count = this.refCount(key);
        if (count === 0) {
          super.remove(key);
        }
      }
    }
  }
  map(key, mapping) {
    const existing = this.mapping.get(key) || [];
    this._mapping.set(key, [...existing, mapping]);
  }
  increment(key) {
    const val = this.refCount(key);
    this.refs.set(key, val + 1);
  }
  decrement(key) {
    const val = this.refCount(key);
    if (val > 0) {
      this.refs.set(key, val - 1);
    }
  }
  refCount(key) {
    return this.refs.get(key) || 0;
  }
}
var _default = exports.default = LegendStore;
module.exports = exports.default;